// Google Tag Manager - GA Daktela chat tracking
function daktelaChatTracking() {
  if (typeof gtag === 'function') {
    $("body").on("click", "#daktela-web .dw-button", function(e){
        gtag('event', 'chat',  {
            "send_to": "UA",
            'state': 'bubble_click'
        });
    });
    $("body").on("click", "#daktela-web .dw-body-form form input[type=submit]", function(e){
        gtag('event', 'chat',  {
            "send_to": "UA",
            'state': 'send_first_message'
        });
    });
    $("body").on("click", "#daktela-web .dw-body-after-conversation form input[type=submit]", function(e){
        gtag('event', 'chat',  {
            "send_to": "UA",
            'state': 'restart_chat'
        });
    });
  }
}